module.exports = __webpack_public_path__ + "media/music/saw_lead_8-b71b4d5a.mp3";